import { Col, View } from "@amzn/stencil-react-components/layout";
import { MessageBanner, MessageBannerType } from "@amzn/stencil-react-components/message-banner";
import React, { FC } from "react";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import { DeliverySummaryBlock } from "./components/delivery-summary-block";
import { DeviceSummaryBlock } from "./components/device-summary-block";
import { REVIEW_STRING_KEYS } from "./components/review.constants";

export interface ReviewStepProps {
  assetId: string;
  category: string;
  onEditDevice: () => void;
  onEditDelivery: () => void;
  submitFailed: boolean;
}

export const ReviewStep: FC<ReviewStepProps> = ({
  assetId,
  category,
  onEditDevice,
  onEditDelivery,
  submitFailed,
}) => (
  <Col gridGap="S400" width="100%">
    <DeviceSummaryBlock assetId={assetId} category={category} onEdit={onEditDevice} />
    <DeliverySummaryBlock onEdit={onEditDelivery} />
    {submitFailed && (
      <View role="alert" width="100%" data-testid="review-submit-error">
        <MessageBanner type={MessageBannerType.Error} isDismissible={false}>
          {getString(REVIEW_STRING_KEYS.submitError)}
        </MessageBanner>
      </View>
    )}
  </Col>
);
